export default __webpack_public_path__ + "static/media/Mojitos.121ebc14.jpg";